import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Sprint 12+K-Hotfix2 (Prod-Frontend-Guard)
 *
 * In Production routet der Ingress `GET /` immer an die React-SPA (Port 3000).
 * Der Backend-Root-Handler (302) läuft dort NIE für User-Traffic.
 * Deshalb macht dieser Guard clientseitig, was der Backend-Handler tut:
 * - GET /api/prelaunch/status abfragen (mit Cookies für User-Status).
 * - Bei prelaunch=true → <Navigate to={target} replace />.
 * - Sonst Children (LandingPage) rendern.
 *
 * Der Loading-State ist bewusst UNSICHTBAR (leerer Container), damit
 * beim schnellen Anonym-Fall kein Flash sichtbar wird. Bei Netzwerkfehler
 * fallback zu Children (Landing sehen ist besser als weißer Screen).
 */
export default function PrelaunchGuard({ children }) {
  const [state, setState] = useState({ loading: true, target: null });

  useEffect(() => {
    let cancelled = false;
    api
      .get("/prelaunch/status")
      .then((res) => {
        if (cancelled) return;
        const data = res.data || {};
        if (data.prelaunch && data.target) {
          setState({ loading: false, target: data.target });
        } else {
          setState({ loading: false, target: null });
        }
      })
      .catch(() => {
        if (cancelled) return;
        // Fail-open: bei Netzwerkfehler Landing zeigen.
        setState({ loading: false, target: null });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.loading) {
    return (
      <div
        data-testid="prelaunch-guard-loading"
        style={{
          minHeight: "100vh",
          background: "#0b1220",
        }}
      />
    );
  }

  if (state.target) {
    return <Navigate to={state.target} replace data-testid="prelaunch-guard-redirect" />;
  }

  return children;
}
